export default __webpack_public_path__ + "static/media/product-1-min.a4c2bc13.jpg";